import * as E from 'io-ts/Encoder';

export const StringToArray: E.Encoder<unknown[], unknown | unknown[]> = {
    encode: s => Array.isArray(s) ? s : [s],
};
